import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import UnitTimePicker from "./UnitTimePicker";

export default withStyles(styles, { name: "HvTimePickerUnitTimePicker" })(UnitTimePicker);
